<template>
    <div class="tw-p-4">
        <div class="tw-flex tw-justify-between tw-items-start">
            <h1 class="tw-text-3xl">
                Zusammenfassung aktuelle Auslagenerstattung
            </h1>

            <i class="fa fa-times tw-text-2xl tw-cursor-pointer" title="Overlay schließen" @click="closeModal"></i>
        </div>

        <hr class="tw-my-4">

        <table class="cu-table cu-table-striped">
            <tbody v-if="expenseReimbursement !== null">
                <tr v-for="(cost, i) in expenseReimbursement.costs">
                    <td>Datum: <span v-text="new Date(cost.date).toLocaleDateString('de-DE')"></span></td>
                    <td>Kostenart: <span v-text="cost.type"></span></td>
                    <td>Kosten: <span v-text="cost.amount"></span>€</td>
                    <td>Kostenstelle: <span v-text="getCostCenterName(cost.cost_carrier_center)"></span></td>
                    <td>Kostenträger: <span v-text="getCostCarrierName(cost.cost_carrier)"></span></td>
                    <td v-if="Attachments[i] != undefined"><a class="cu-btn-default-sm" :href="`/attachments/${Attachments[i].id}`"><i class="fa fa-file-text-o"></i></a></td>
                    <td v-if="Attachments[i] == undefined"><i class="cu-btn-default-sm fa fa-file-text-o tw-opacity-50 tw-pointer-events-none tw-cursor-not-allowed" disabled></i></td>
                </tr>
                <tr>
                    <td colspan="5">
                        <div class="tw-flex tw-justify-between tw-font-bold tw-text-2xl">
                            <div>
                                Gesamtbetrag Auslagenerstattung:
                            </div>
                            <div v-text="Helpers.formatPrice(Helpers.reimbursementCostsTotal())"></div>
                        </div>
                    </td>
                </tr>
            </tbody>
            <tbody v-if="travelExpenseReport !== null">
                <tr>
                    <td>Reiseroute:</td>
                    <td colspan="3" v-text="travelExpenseReport.route"></td>
                    <td></td>
                </tr>
                <tr>
                    <td>Anlass der Reise:</td>
                    <td colspan="3" v-text="travelExpenseReport.reason_for_trip"></td>
                </tr>
                <tr>
                    <td>Reisedauer:</td>
                    <td colspan="3" v-text="travelDuration"></td>
                    <td></td>
                </tr>
                <tr>
                    <td>Reiseart:</td>
                    <td v-text="transportationType"></td>
                    <td>Gesamtkosten:</td>
                    <td v-text="Helpers.formatPrice(Helpers.transportationTotalCosts())"></td>
                    <td>
                        <button
                            v-if="hasAttachments('public_transport')"
                            type="button"
                            class="cu-btn-default-sm tw-ml-2"
                            @click="toggleAttachments('public_transport')"
                            title="Belege anzeigen"
                        >
                            <i class="fa fa-paperclip"></i>
                            <span class="tw-ml-1">({{ attachmentsFor('public_transport').length }})</span>
                        </button>

                        <span v-else class="tw-text-gray-400 cu-btn-default-sm tw-opacity-50 tw-pointer-events-none tw-cursor-default tw-ml-2">
                            <i class="fa fa-paperclip"></i>
                            <span class="tw-ml-1">(0)</span>
                        </span>
                    </td>
                </tr>
                <tr v-if="openAttachmentKey === 'public_transport'">
                    <td colspan="4">
                        <ul class="tw-mt-2 tw-ml-0 tw-list-none tw-flex tw-gap-x-4">
                        <li v-for="(att, idx) in attachmentsFor('public_transport')" :key="att.id ?? idx">
                            <a
                            class="tw-underline"
                            :href="attachmentUrl(att)"
                            target="_blank"
                            rel="noopener"
                            >
                            {{ att.original_name ?? att.name ?? `Beleg ${idx + 1}` }}
                            </a>
                        </li>
                        </ul>
                    </td>
                    <td colspan="3"></td>
                </tr>
                <tr>
                    <td>Übernachtung:</td>
                    <td v-text="travelExpenseReport.travel_information.overnight_stay.hotel || '-'">-</td>
                    <td>Gesamtkosten:</td>
                    <td v-text="Helpers.formatPrice(Helpers.overnightStayTotalCosts())"></td>
                    <td>
                        <button
                            v-if="hasAttachments('overnight_stay')"
                            type="button"
                            class="cu-btn-default-sm tw-ml-2"
                            @click="toggleAttachments('overnight_stay')"
                            title="Belege anzeigen"
                        >
                            <i class="fa fa-paperclip"></i>
                            <span class="tw-ml-1">({{ attachmentsFor('overnight_stay').length }})</span>
                        </button>

                        <span v-else class="tw-text-gray-400 cu-btn-default-sm tw-opacity-50 tw-pointer-events-none tw-cursor-default tw-ml-2">
                            <i class="fa fa-paperclip"></i>
                            <span class="tw-ml-1">(0)</span>
                        </span>
                    </td>
                </tr>
                <tr v-if="openAttachmentKey === 'overnight_stay'">
                    <td colspan="4">
                        <ul class="tw-mt-2 tw-ml-0 tw-list-none tw-flex tw-gap-x-4">
                        <li v-for="(att, idx) in attachmentsFor('overnight_stay')" :key="att.id ?? idx">
                            <a
                            class="tw-underline"
                            :href="attachmentUrl(att)"
                            target="_blank"
                            rel="noopener"
                            >
                            {{ att.original_name ?? att.name ?? `Beleg ${idx + 1}` }}
                            </a>
                        </li>
                        </ul>
                    </td>
                    <td colspan="3"></td>
                </tr>
                <tr>
                    <td>Sonstige Auslagenerstattungen:</td>
                    <td></td>
                    <td>Gesamtkosten:</td>
                    <td v-text="Helpers.formatPrice(Helpers.otherCostsTotal())"></td>
                    <td>
                        <button
                            v-if="hasAttachments('other_costs')"
                            type="button"
                            class="cu-btn-default-sm tw-ml-2"
                            @click="toggleAttachments('other_costs')"
                            title="Belege anzeigen"
                        >
                            <i class="fa fa-paperclip"></i>
                            <span class="tw-ml-1">({{ attachmentsFor('other_costs').length }})</span>
                        </button>

                        <span v-else class="tw-text-gray-400 cu-btn-default-sm tw-opacity-50 tw-pointer-events-none tw-cursor-default tw-ml-2">
                            <i class="fa fa-paperclip"></i>
                            <span class="tw-ml-1">(0)</span>
                        </span>
                    </td>
                </tr>
                <tr v-if="openAttachmentKey === 'other_costs'">
                    <td colspan="4">
                        <ul class="tw-mt-2 tw-ml-0 tw-list-none tw-flex tw-gap-x-4">
                        <li v-for="(att, idx) in attachmentsFor('other_costs')" :key="att.id ?? idx">
                            <a
                            class="tw-underline"
                            :href="attachmentUrl(att)"
                            target="_blank"
                            rel="noopener"
                            >
                            {{ att.original_name ?? att.name ?? `Beleg ${idx + 1}` }}
                            </a>
                        </li>
                        </ul>
                    </td>
                    <td colspan="3"></td>
                </tr>
                <tr>
                    <td>Verpflegungsmehraufwand:</td>
                    <td></td>
                    <td>Gesamtkosten:</td>
                    <td v-text="Helpers.formatPrice(Helpers.dailyAllowanceTotalCosts())"></td>
                    <td></td>
                </tr>
                <tr>
                    <td>Kostenstelle:</td>
                    <td colspan="3" v-text="costCenterName"></td>
                    <td></td>
                </tr>
                <tr>
                    <td>Kostenträger:</td>
                    <td colspan="3" v-text="costCarrierName"></td>
                    <td></td>
                </tr>
                <tr>
                    <td colspan="4">
                        <div class="tw-flex tw-justify-between tw-font-bold tw-text-2xl">
                            <div>
                                Gesamtbetrag Auslagenerstattung:
                            </div>
                            <div v-text="Helpers.formatPrice(Helpers.totalCosts())"></div>
                        </div>
                    </td>
                    <td colspan="3"></td>
                </tr>
            </tbody>
        </table>
        <div v-if="expenseReimbursement != null">
            <div class="tw-flex tw-flex-col tw-justify-between tw-text-xl tw-ml-4" v-if="(expenseReimbursement != null && expenseReimbursement.disapprove_comment)">
                <div class="tw-flex">
                    Ablehnungskommentar
                </div>
                <div class="tw-break-words tw-whitespace-pre-wrap tw-text-lg" v-text="expenseReimbursement.disapprove_comment"></div>
            </div>
        </div>
        <div v-if="travelExpenseReport != null">
            <div class="tw-flex tw-flex-col tw-justify-between tw-text-xl tw-ml-4" v-if="(travelExpenseReport != null && travelExpenseReport.disapprove_comment)">
                <div class="tw-flex">
                    Ablehnungskommentar
                </div>
                <div class="tw-break-words tw-whitespace-pre-wrap tw-text-lg" v-text="travelExpenseReport.disapprove_comment"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import {Constants, TravelTypes, OvernightPaymentTypes, Helpers} from "./TravelExpenseReport";

    export default {
        props: {
            travelExpenseReport: {
                type: Object,
                required: false,
                default: null,
            },
            expenseReimbursement: {
                type: Object,
                required: false,
                default: null,
            },
            costCenters: {
                type: Array,
                required: true,
            },
            costCarriers: {
                type: Array,
                required: true,
            },
            disapproveComment: {
                type: String,
                required: false,
            },
            attachments: {
                required: false,
            }
        },

        data() {
            return {
                Constants: Constants,
                TravelTypes: TravelTypes,
                OvernightPaymentTypes: OvernightPaymentTypes,
                Helpers: new Helpers(this.travelExpenseReport, this.expenseReimbursement),
                Comment: this.disapproveComment ?? null,
                Attachments: this.attachments ?? [],
                openAttachmentKey: "",
            }
        },

        methods: {
            closeModal() {
                this.$emit('close');
            },

            getCostCarrierById(costCarriers, id, path) {
                let result = null;

                costCarriers.forEach(costCarrier => {
                    if (costCarrier.id === id) {
                        result = costCarrier;
                        path.push(costCarrier.label);
                    }

                    if (!! costCarrier.children && costCarrier.children.length > 0) {
                        let c = this.getCostCarrierById(costCarrier.children, id, path);

                        if (!! c) {
                            result = c;
                            path.push(costCarrier.label);
                        }
                    }
                });

                return result;
            },

            getCostCenterName(costCenterId) {
                let name = '-';
                this.costCenters.forEach(costCenter => {
                    if (costCenter.id === costCenterId) {
                        name = costCenter.name;
                    }
                });

                return name;
            },

            getCostCarrierName(costCarrierId) {
                let name = [];
                this.getCostCarrierById(this.costCarriers, costCarrierId, name);
                return name.reverse().join(' > ');
            },

            toggleAttachments(key) {
                this.openAttachmentKey = (this.openAttachmentKey === key) ? null : key;
            },

            attachmentsFor(key) {
                const list = this.attachments?.[key];
                return Array.isArray(list) ? list : [];
            },

            hasAttachments(key) {
                return this.attachmentsFor(key).length > 0;
            },

            attachmentUrl(att) {
                const key = att?.id ?? att; // supports both object or id
                return key ? `/attachments/${key}` : '#';
            },
        },

        computed: {
            travelDuration() {
                let start = null;
                let end = null;

                this.travelExpenseReport.travel_information.period.forEach(day => {
                    if (day.date === null) {
                        return;
                    }

                    let date = moment(day.date);

                    if (start === null || date.isBefore(start)) {
                        start = day.date;
                    }
                    if (end === null || date.isAfter(end)) {
                        end = day.date;
                    }
                });

                if (! start || ! end) {
                    return '-';
                }

                return moment(start).format('DD.MM.YYYY') + ' - ' + moment(end).format('DD.MM.YYYY');
            },

            transportationType() {
                let transportationType = '-';

                this.TravelTypes.forEach(item => {
                    if (item.value === this.travelExpenseReport.travel_information.transportation_type) {
                        transportationType = item.title;
                    }
                })

                return transportationType;
            },

            costCarrierName() {
                if (this.travelExpenseReport !== null) {
                    if (this.travelExpenseReport.cost_carrier_id > 0) {
                        return this.getCostCarrierName(this.travelExpenseReport.cost_carrier_id);
                    }
                }

                return '-';
            },

            costCenterName() {
                let name = '-';

                if (this.travelExpenseReport !== null) {
                    if (this.travelExpenseReport.cost_center_id > 0) {
                        name = this.getCostCenterName(this.travelExpenseReport.cost_center_id);
                    }
                }

                return name;
            }
        },

        mounted() {
            //
        }
    }
</script>
